"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopOverPresentationControl = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PopOverPresentationControl = require("./PopOverPresentationControl.styled");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var PopOverPresentationControl = exports.PopOverPresentationControl = function PopOverPresentationControl(_ref) {
  var _value$activePage, _value$numPages;
  var value = _ref.value,
    onSubmit = _ref.onSubmit,
    onCancel = _ref.onCancel;
  var activePage = (_value$activePage = value === null || value === void 0 ? void 0 : value.activePage) !== null && _value$activePage !== void 0 ? _value$activePage : 1;
  var numPages = (_value$numPages = value === null || value === void 0 ? void 0 : value.numPages) !== null && _value$numPages !== void 0 ? _value$numPages : 0;
  var _useState = (0, _react.useState)(activePage),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    inputPageNumber = _useState2[0],
    setInputPageNumber = _useState2[1];
  var presentationFooterRef = (0, _react.useRef)(null);
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    showInputForm = _useState4[0],
    setShowInputForm = _useState4[1];
  var pageNumberInputHasError = inputPageNumber > numPages || inputPageNumber === 0;
  (0, _react.useEffect)(function () {
    document.addEventListener('click', handleClick);
    return function () {
      document.removeEventListener('click', handleClick);
    };
  }, [activePage]);
  var handleClick = function handleClick(event) {
    var isOutsidePresentationFooterClick = presentationFooterRef.current && !presentationFooterRef.current.contains(event.target);
    setShowInputForm(!isOutsidePresentationFooterClick);
  };
  var handlePageInputKeyPress = function handlePageInputKeyPress(event) {
    if (event.key === 'Enter' && !pageNumberInputHasError) {
      event.preventDefault();
      event.target.blur();
      setShowInputForm(false);
      onSubmit(inputPageNumber);
    }
  };
  var handlePageInputChange = function handlePageInputChange(event) {
    if (isNaN(event.target.value)) {
      return;
    }
    setInputPageNumber(+event.target.value);
  };
  var _onSubmit = function _onSubmit() {
    onSubmit(inputPageNumber);
  };
  if (numPages === 0) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "popover-presentation-control"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: presentationFooterRef
  }, "Set current slide to", pageNumberInputHasError ? /*#__PURE__*/_react["default"].createElement(_PopOverPresentationControl.StyledFontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faTriangleExclamation,
    color: "#DE2F1B",
    "data-testid": "page-number-input-error"
  }) : /*#__PURE__*/_react["default"].createElement(_PopOverPresentationControl.StyledPlaceholderInputError, null), /*#__PURE__*/_react["default"].createElement(_PopOverPresentationControl.StyledPageInput, {
    $hasError: pageNumberInputHasError,
    onChange: handlePageInputChange,
    type: "text",
    value: inputPageNumber,
    onKeyPress: handlePageInputKeyPress,
    readOnly: !showInputForm,
    "data-testid": "page-number-input"
  }), "of ".concat(numPages)), /*#__PURE__*/_react["default"].createElement(_PopOverPresentationControl.StyledButtonContainer, null, /*#__PURE__*/_react["default"].createElement(_PopOverPresentationControl.StyledButton, {
    size: "small",
    variant: "outlined",
    "data-testid": "cancel-button",
    onClick: onCancel
  }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_PopOverPresentationControl.StyledButton, {
    size: "small",
    "data-testid": "submit-button",
    disabled: pageNumberInputHasError,
    onClick: _onSubmit
  }, "Done")));
};
PopOverPresentationControl.propTypes = {
  value: _propTypes["default"].object.isRequired,
  onSubmit: _propTypes["default"].func.isRequired,
  onCancel: _propTypes["default"].func.isRequired
};